import {useCallback, useEffect, useState} from 'react';
import {AuthService} from '@services/AuthService';
import Keycloak, {KeycloakConfig} from 'keycloak-js';

export const useAuth = () => {
    const [authInfo, setAuthInfo] = useState<KeycloakConfig>();
    const [isLogin, setIsLogin] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    const setAuthInfoHandle = useCallback(() => {
        AuthService.getAuthInfo()
            ?.then((data) => {
                const newKeycloakConfig: KeycloakConfig = {
                    realm: data.realm,
                    clientId: data.clientId,
                    url: data.authServerUrl,
                };
                setAuthInfo(newKeycloakConfig);
            })
            .catch(() => setIsError(true));
    }, []);

    const setIsLoginHandle = useCallback(async () => {
        if (authInfo) {
            const authenticated = await AuthService.init(authInfo);

            if (authenticated) {
                setIsLogin(true);
                startTokenRefresh(AuthService.instance);
            } else {
                await AuthService.login();
            }
        }
    }, [authInfo]);

    useEffect(() => {
        void setAuthInfoHandle();
    }, [setAuthInfoHandle]);

    useEffect(() => {
        void setIsLoginHandle();
    }, [setIsLoginHandle]);

    return {isLogin, isError};
};

const startTokenRefresh = (kc: Keycloak) => {
    const refreshInterval = setInterval(() => {
        kc.updateToken(60)
            .then((refreshed) => {
                if (refreshed) console.debug('🔄 Token refreshed');
            })
            .catch(() => {
                console.warn('⚠️ Token refresh failed, redirecting to login');
                kc.login();
            });
    }, 60000);
    return () => clearInterval(refreshInterval);
};
